import { IFormParsed } from '@infotech-soe/metaschema';

import {
  BuiltinCaptionType,
  CaptionType,
} from '../../../models/caption/Caption';
import { FormTitle } from '../FormTitle';

export enum TreeFormFieldNames {
  TARGET_ID = 'treeId',
}

class TreeFormSchemaFactory {
  public getTitle(): FormTitle {
    return {
      type: CaptionType.BUILT_IN,
      caption: BuiltinCaptionType.MOVE,
    };
  }

  public async getFormSchema(): Promise<IFormParsed> {
    return {
      Fields: {},
      Layout: [
        {
          name: TreeFormFieldNames.TARGET_ID,
          control: 'Tree',
        },
      ],
    };
  }
}

export default TreeFormSchemaFactory;
